import { color } from "@/styles/primitives";
import type { _SVGIcon } from "hsl-core/Components";

export const FILL = color.sand;

const body: _SVGIcon.IconBody = (params) => {
	const fill = params?.fill ?? FILL;
	return `
    <path d="M2.5 3L4 0H2L0 4H2L1 7H2.5L4 3H2.5Z" fill="${fill}"/>
  `;
};

export default {
	W: 4,
	H: 7,
	body,
} as _SVGIcon.Icon;
